<template>
  <div class="car-paper">
    <div id="car" class="car-page" :style="'background-image: url(' + dashboardBg + ');zoom: ' + zoom + ';'">
      <div class="dashboard-title">甲醇燃料电池汽车运行状况AI诊断仿真平台</div>
      <!--刷新-->
      <div class="left-bottom-box">
        <span class="el-icon-s-home setting" @click="handleToIndex"></span>
        <img src="../assets/debug.png" alt="" class="debug" @click="handleDebug">
        <span class="el-icon-setting setting" @click="handleSetting"></span>
        <img src="../assets/refresh.png" alt="" class="refresh" @click="handleRefresh">
      </div>

      <!--左边信息-->
      <div class="left-info-wrapper">
        <div class="mileage-box">
          <div class="left-title">里程信息</div> <!-- 总里程信息-->
          <div class="content">
            <span class="num">{{ params.full_mileage | formatNumber }}</span>
            <!--<span class="num">146546.2</span>-->
            <span class="unit">km</span>
          </div>
        </div>
        <div class="speed-box">
          <div class="left-title">速度信息</div>
          <div class="speed-img">
            <img src="../assets/car-speed.png" alt="">
          </div>
          <div class="num">{{ params.running_speed }}</div>
          <div class="unit">km/h</div>
        </div>
      </div>
      <!--右边信息-->
      <div class="right-info-wrapper">
        <div class="methanol-box">
          <div class="right-title">余醇信息</div>
          <div class="content">
            <div class="methanol">
              <div style="display: flex;justify-content: space-between;">
                <div style="display: flex;flex-direction: column; justify-content: space-between;flex: 1;">
                  <div>
                    <div class="text-right">
                      <!--甲醇容量-->
                      <span class="number">{{ params.methanol_full_amount | formatNumber }}</span>
                      <span class="unit">L</span>
                    </div>
                    <div class="name text-right">FullCapacity</div>
                  </div>
                  <div class="text-right">
                    <div>
                      <!--甲醇余量-->
                      <span class="number">{{ params.methanol_left_amount | formatNumber }}</span>
                      <span class="unit">L</span>
                    </div>
                    <div class="name text-right">Remaining</div>
                  </div>
                </div>
                <div style="width: 22px;margin-left: 12px">
                  <div class="h-line color-methanol" v-for="i in 20" :key="i"
                       :class="i > getLineVal(params.methanol_full_amount,params.methanol_left_amount)?
                      (params.methanol_left_amount/params.methanol_full_amount <0.2?'warning':'active')
                      : ''">
                  </div>
                </div>
              </div>
              <div class="text-right padding-top-16">甲醇</div>
            </div>

            <div class="water">
              <div style="display: flex;justify-content: space-between">
                <div style="width: 22px;margin-right: 12px">
                  <div class="h-line color-water" v-for="i in 20" :key="i"
                       :class="i> getLineVal(params.water_full_amount,params.water_left_amount)?
                     (params.water_left_amount/params.water_full_amount < 0.2 ? 'warning': 'active'): ''">
                  </div>
                </div>
                <div style="display: flex;flex-direction: column; justify-content: space-between;flex: 1;">
                  <div class="text-left">
                    <div>
                      <!--水容量-->
                      <span class="number">{{ params.water_full_amount | formatNumber }}</span>
                      <span class="unit">L</span>
                    </div>
                    <div class="name">FullCapacity</div>
                  </div>
                  <div class="text-left">
                    <div>
                      <span class="number">{{ params.water_left_amount | formatNumber }}</span>
                      <span class="unit">L</span>
                    </div>
                    <div class="name">Remaining</div>
                  </div>
                </div>
              </div>
              <div class="text-left padding-top-16">水</div>
            </div>
          </div>
        </div>

        <div class="electric-box">
          <div class="right-title">电量信息</div>
          <div class="line-box">
            <div class="v-line color-electric" v-for="i in 20" :key="i"
                 :class="i> (20 -getLineVal(params.power_full_amount,params.power_left_amount))?
               '': (params.power_left_amount/params.power_full_amount <0.2?'warning':'active')"></div>
          </div>
          <div class="content">
            <div>
              <div>
                <span class="number">{{ params.power_left_amount | formatNumber }}</span>
                <span class="unit">Kwh</span>
              </div>
              <div class="name">Remaining</div>
            </div>
            <div>
              <div>
                <span class="number">{{ params.power_full_amount | formatNumber }}</span>
                <span class="unit">Kwh</span>
              </div>
              <div class="name">FullCapacity</div>
            </div>

          </div>
        </div>
      </div>
      <!--底部操作-->
      <div class="bottom-opr-wrapper">
        <div @click="run" :style="'background-image: url(' + (is_running? optBtnBgY:optBtnBgB) + ');'" class="opr-btn">
          {{ is_running ? '已启动' : '启动车辆' }}
        </div>
        <div @mousedown="speedAddStart" @mouseup="speedAddEnd" @mouseout="speedAddEnd"
             :style="'background-image: url(' + ((speed_add_sh || keyStatus=='ArrowUp')? optBtnBgY : optBtnBgB) + ');'"
             class="opr-btn">
          车辆加速
        </div>
        <div @mousedown="speedSubStart" @mouseup="speedSubEnd" @mouseout="speedSubEnd"
             :style="'background-image: url(' + ((speed_sub_sh || keyStatus=='ArrowDown')? optBtnBgY : optBtnBgB) + ');'"
             class="opr-btn">
          车辆减速
        </div>
        <div @click="pause" :style="'background-image: url(' + (!is_running? optBtnBgY:optBtnBgB) + ');'"
             class="opr-btn">
          停止运行
        </div>
      </div>

      <!--汽车-->
      <div class="dashboard-container">
        <div class="car-container">
          <img src="../assets/car.png" alt="" class="car-img"/>
          <!--气体流动-->
          <div class="car-line-wrapper">
            <img src="../assets/car-words.png" alt="" class="car-words">
            <img src="../assets/car-lines.png" alt="" class="car-lines"/>
            <div class="gas-y-1" v-show="params.running_speed >0"></div>
            <div class="gas-y-2" v-show="params.running_speed >0"></div>
            <div class="gas-y-3" v-show="params.running_speed >0"></div>
            <div class="gas-y-6" v-show="machine_is_running &&params.running_speed >0"></div>
            <template v-if="machine_is_running">
              <div class="gas-y-4"></div>
              <div class="gas-y-5"></div>
              <div class="gas-blue-1"></div>
              <div class="gas-pink-1"></div>
              <div class="gas-pink-2"></div>
              <div class="gas-green-1"></div>
              <div class="gas-green-2"></div>
            </template>
          </div>
          <!--轮胎-->
          <img src="../assets/tyre-left.png" alt="" class="tyre left"
               :class="is_running&&params.running_speed >0?'round': ''"/>
          <img src="../assets/tyre-left.png" alt="" class="tyre right"
               :class="is_running &&params.running_speed >0? 'round': ''"/>
        </div>
      </div>

      <!--提示框-->
      <div class="tip-container" v-if="notifyRules.length">
        <div :key="key" class="tip-box" v-for="(item, key) in notifyRules"
             :style="'background-image: url(' + dialogArr[String(item.level)] + ');'">
          <!--关闭-->
          <p class="top-close" @click="removeNotify(key)"></p>
          <div class="img-box">
            <img src="../assets/dialog-img-1.png" alt="" v-show="item.level == 1"/>
            <img src="../assets/dialog-img-2.png" alt="" v-show="item.level == 2"/>
            <img src="../assets/dialog-img-3.png" alt="" v-show="item.level == 3"/>
            <span :class="'tip-color-'+ item.level">{{ notifyName['level' + item.level] }}</span>
          </div>
          <div class="msg">{{ item.message }}</div>
        </div>
      </div>
      <!--各种变量-->
      <div class="params-container" v-if="is_debug">
        <p>是否启动: {{ is_running ? '是' : '否' }}&emsp;&emsp;
          车辆速度: {{ params.running_speed }}km/h</p>
        <hr>
        <p>&emsp;&emsp;&emsp;&emsp;&emsp;总里程: {{ params.full_mileage }}km</p>
        <p>&emsp;&emsp;&emsp;&emsp;总耗电量: {{ params.full_power_consumption }}kwh</p>
        <p>&emsp;&emsp;&emsp;总启动时长: {{ params.full_run_seconds | toLocalTime }}</p>
        <p>&emsp;&emsp;&emsp;&emsp;本次里程: {{ params.mileage }}km</p>
        <p>&emsp;本次里程耗电量: {{ params.power_consumption }}kwh</p>
        <p>&emsp;&emsp;本次启动时长: {{ params.run_seconds | toLocalTime }}</p>
        <p>&emsp;&emsp;&emsp;&emsp;甲醇容量: {{ params.methanol_full_amount }}L</p>
        <p>&emsp;&emsp;&emsp;&emsp;甲醇余量: {{ params.methanol_left_amount }}L</p>
        <p>&emsp;&emsp;&emsp;&emsp;&emsp;水容量: {{ params.water_full_amount }}L</p>
        <p>&emsp;&emsp;&emsp;&emsp;&emsp;水余量: {{ params.water_left_amount }}L</p>
        <p>&emsp;&emsp;&emsp;&emsp;电池容量: {{ params.power_full_amount }}kwh</p>
        <p>&emsp;&emsp;&emsp;&emsp;电池余量: {{ params.power_left_amount }}kwh</p>
        <hr>
        <p><strong>甲醇重整器参数</strong></p>
        <p>&emsp;&emsp;&emsp;运行总时长: {{ params.machine_full_run_seconds | toLocalTime }}</p>
        <p>&emsp;&emsp;本次启动时长: {{ params.machine_run_seconds | toLocalTime }}</p>
        <p>&emsp;&nbsp;&nbsp;当前环境PH值: {{ params.machine_ph }}</p>
        <p>&emsp;&emsp;&emsp;&emsp;当前温度: {{ params.machine_temperature }}°</p>
        <p>&emsp;&emsp;&emsp;&emsp;当前气压: {{ params.machine_pressure }}Mp</p>
        <p>&emsp;&emsp;&emsp;&emsp;加醇总量: {{ params.machine_methanol_amount }}L</p>
        <p>&emsp;&emsp;&emsp;&emsp;耗醇总量: {{ params.machine_methanol_full_consume_amount }}L</p>
        <p>&emsp;本次启动耗醇量: {{ params.machine_methanol_consume_amount }}L</p>
        <p>&emsp;&emsp;&emsp;&emsp;当前醇耗: {{ params.machine_methanol_consume_ratio }}</p>
        <p>&emsp;&emsp;&emsp;&emsp;加水总量: {{ params.machine_water_amount }}L</p>
        <p>&emsp;&emsp;&emsp;&emsp;耗水总量: {{ params.machine_water_full_consume_amount }}L</p>
        <p>&emsp;本次启动耗水量: {{ params.machine_water_consume_amount }}L</p>
        <p>&emsp;&emsp;&emsp;&emsp;当前水耗: {{ params.machine_water_consume_ratio }}</p>
        <p>&emsp;&emsp;&emsp;当前水醇比: {{ params.machine_water_methanol_ratio }}</p>
        <p>&emsp;本次启动发电量: {{ params.machine_create_power }}kwh</p>
        <p>&emsp;蒸气成分氯含量: {{ params.machine_cl_ratio }}</p>
        <p>&emsp;蒸气成份硫含量: {{ params.machine_s_ratio }}</p>
        <hr>
        <p><strong>产物气体含量</strong></p>
        <p>CH3OH: {{ params.machine_ch3oh_ratio }}</p>
        <p>CO: {{ params.machine_co_ratio }}</p>
        <p>H20: {{ params.machine_h2o_ratio }}</p>
        <p>CO2: {{ params.machine_co2_ratio }}</p>
        <p>H2: {{ params.machine_h2_ratio }}</p>
        <p>积碳检测: {{ params.machine_carbon_deposition ? '有' : '无' }}</p>
        <hr>
        <p>{{ debug_content }}</p>
        <hr>
      </div>
    </div>
  </div>
</template>

<script>
import {alarmRules, paramsLast, paramsUpdate} from "@/api/car"
import {computed} from "vue"

export default {
  name: "CarComponents",
  data() {
    return {
      type: 'car',

      zoom: 1,
      dashboardBg: require('@/assets/carBg.jpg'),
      optBtnBgY: require('@/assets/btn-bg-yellow.png'),
      optBtnBgB: require('@/assets/btn-bg-blue.png'),
      //
      is_debug: false,
      //
      is_running: false, // 是否运行
      running_sh: null, // 运行sh
      machine_is_running: false, // 甲醇重整器 是否运行

      speed_add_sh: null,
      speed_sub_sh: null,
      keyStatus: null,
      //
      maxMethanolAmount: 50, //甲醇最大容量
      maxWaterAmount: 65, //水最大容量
      maxPowerAmount: 50, //水最大容量

      params: {
        running_speed: 0, // 速度 km/h
        last_running_speed: 0, // 速度 km/h 上一次
        last_stop_timestamp: 0, // 上一次停车（运行中但速度为0）时间戳
        full_mileage: 0, // 总里程 km
        mileage: 0, // 本次里程 km  2024-07-23 添加
        full_power_consumption: 0, //总耗电量 kwh
        full_run_seconds: 0, // 总启动时长 s
        power_consumption: 0, //本次里程耗电量 kwh
        run_seconds: 0, // 本次启动时长 s
        methanol_full_amount: 50, // 甲醇容量 L
        methanol_left_amount: 50, // 甲醇余量 L
        water_full_amount: 65, // 水容量 L
        water_left_amount: 65, // 水余量 L
        power_full_amount: 40, // 电池总容量 kwh
        power_left_amount: 30, // 剩余电量 kwh
        // 甲醇重整器参数
        machine_full_run_seconds: 0, // 运行总时长 s
        machine_run_seconds: 0, // 本次启动时长 s
        machine_ph: 0, // 当前环境PH值
        machine_temperature: 0, // 当前温度
        machine_pressure: 0, // 当前气压
        // 醇
        machine_methanol_amount: 100, // 加醇总量 L
        machine_methanol_full_consume_amount: 0, // 耗醇总量 L
        machine_methanol_consume_amount: 0, // 本次启动耗醇量 L
        machine_methanol_consume_ratio: 0, // 当前醇耗
        // 水
        machine_water_amount: 130, // 加水总量 L
        machine_water_full_consume_amount: 0, // 耗水总量 L
        machine_water_consume_amount: 0, // 本次启动耗水量 L
        machine_water_consume_ratio: 0, // 当前水耗

        machine_water_methanol_ratio: 1.3, // 当前水醇比

        machine_create_power: 0, // 本次启动发电量 kwh
        machine_cl_ratio: 0, // 蒸气成分氯含量
        machine_s_ratio: 0, // 蒸气成份硫含量
        machine_ch3oh_ratio: 0, // 产物气体含量 CH3OH
        machine_co_ratio: 0, // 产物气体含量 CO
        machine_h2o_ratio: 0, // 产物气体含量 H20
        machine_co2_ratio: 0, // 产物气体含量 CO2
        machine_h2_ratio: 0, // 产物气体含量 H2
        machine_carbon_deposition: 0, // 积碳检测
      },
      rules: [],
      //
      dialogArr: {
        '1': require('@/assets/dialog-bg-1.png'),
        '2': require('@/assets/dialog-bg-2.png'),
        '3': require('@/assets/dialog-bg-3.png'),
      },
      notifyName: {
        level1: '严重',
        level2: '提示',
        level3: '普通',
      },
      notifyRules: [
        // {
        //   id: 1,
        //   level: '1', // 1严重 2提示 3 普通
        //   message: "严重严重严重严重严重严重",
        // },
      ],
      debug_content: '甲醇-0,水-0,充电+0,时速0,里程+0,耗电-0',
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
  },
  filters: {
    toLocalTime(seconds) {
      let left_seconds = seconds
      let hour = 0, minute = 0
      if (left_seconds >= 3600) {
        hour = Math.floor(left_seconds / 3600)
        left_seconds = left_seconds % 3600
      }
      if (left_seconds >= 60) {
        minute = Math.floor(left_seconds / 60)
        left_seconds = left_seconds % 60
      }
      return hour + '小时' + minute + '分钟' + left_seconds + '秒'
    },
    formatNumber(num) {
      if (num > 0) {
        if (/[.]/.test(num)) {
          return parseFloat(num).toFixed(1)
        }
        return num
      }
      return num
    }
  },
  created() {
    if (!this.user.has_car_permission) {
      this.$router.replace('/index')
    }
  },
  mounted() {
    let that = this
    that.flushConfig()
    that.calcZoom()
    window.addEventListener('resize', () => {
      that.calcZoom()
    })
    //加速减速-添加快捷键
    document.addEventListener('keydown', this.handleKeyDown)
    document.addEventListener('keyup', this.handleKeyUp)
  },
  beforeDestroy() {
    this.running_sh && clearInterval(this.running_sh)
    this.speed_add_sh && clearInterval(this.speed_add_sh)
    this.speed_sub_sh && clearInterval(this.speed_sub_sh)

    document.removeEventListener('keydown', this.handleKeyDown)
    document.removeEventListener('keyup', this.handleKeyUp)
  },
  methods: {
    calcZoom() {
      let that = this
      let w_radio = window.innerWidth / 1920
      let h_radio = window.innerHeight / 1080
      that.zoom = Math.min(w_radio, h_radio)
    },
    getLineVal(full, left) {
      if (left < 0.1) return 20
      let unit = (full / 20)
      let n = left / unit
      return Math.floor(20 - n)
    },
    // 返回首页
    handleToIndex() {
      if (this.is_running) {
        this.$message.error('请停止运行')
        return
      }
      this.$router.push('/index')
    },
    // 点击刷新
    handleRefresh() {
      if (this.is_running) {
        this.$message.error('请停止运行')
        return
      }
      this.flushConfig()
    },
    // 显示调试信息
    handleDebug() {
      this.is_debug = !this.is_debug
    },
    handleSetting() {
      if (this.is_running) {
        this.$message.error('请停止运行')
        return
      }
      this.$router.push('/car/setting')
    },
    flushConfig() {
      this.getLastParams()
      this.getRules()
    },
    getLastParams() {
      let that = this
      paramsLast({type: that.type}).then(res => {
        that.setParams(res)
      })
    },
    getRules() {
      let that = this
      alarmRules({type: that.type}).then(res => {
        that.rules = res
      })
    },
    updateParams() {
      let that = this
      paramsUpdate({...that.params, type: that.type}).then(() => {

      })
    },
    setParams(params) {
      this.params.last_running_speed = params.last_running_speed || 60
      this.params.full_mileage = params.full_mileage || 0
      this.params.full_power_consumption = params.full_power_consumption || 0
      this.params.full_run_seconds = params.full_run_seconds || 0
      this.params.power_consumption = params.power_consumption || 0
      this.params.run_seconds = params.run_seconds || 0
      // this.params.methanol_full_amount = params.methanol_full_amount || 0
      this.params.methanol_left_amount = params.methanol_left_amount || 0
      // this.params.water_full_amount = params.water_full_amount || 0
      this.params.water_left_amount = params.water_left_amount || 0
      // this.params.power_full_amount = 50
      this.params.power_left_amount = params.power_left_amount || 0
      this.params.machine_full_run_seconds = params.machine_full_run_seconds || 0
      this.params.machine_run_seconds = params.machine_run_seconds || 0
      this.params.machine_ph = params.machine_ph || 0
      this.params.machine_temperature = params.machine_temperature || 0
      this.params.machine_pressure = params.machine_pressure || 0
      this.params.machine_methanol_amount = params.machine_methanol_amount || 0
      this.params.machine_methanol_full_consume_amount = params.machine_methanol_full_consume_amount || 0
      this.params.machine_methanol_consume_amount = params.machine_methanol_consume_amount || 0
      // this.params.machine_methanol_consume_ratio = params.machine_methanol_consume_ratio || 0
      this.params.machine_water_amount = params.machine_water_amount || 0
      this.params.machine_water_full_consume_amount = params.machine_water_full_consume_amount || 0
      this.params.machine_water_consume_amount = params.machine_water_consume_amount || 0
      // this.params.machine_water_consume_ratio = params.machine_water_consume_ratio || 0
      this.params.machine_water_methanol_ratio = params.machine_water_methanol_ratio || 0
      this.params.machine_create_power = params.machine_create_power || 0
      this.params.machine_cl_ratio = params.machine_cl_ratio || 0
      this.params.machine_s_ratio = params.machine_s_ratio || 0
      this.params.machine_ch3oh_ratio = params.machine_ch3oh_ratio || 0
      this.params.machine_co_ratio = params.machine_co_ratio || 0
      this.params.machine_h2o_ratio = params.machine_h2o_ratio || 0
      this.params.machine_co2_ratio = params.machine_co2_ratio || 0
      this.params.machine_h2_ratio = params.machine_h2_ratio || 0
      this.params.machine_carbon_deposition = params.machine_carbon_deposition ? 1 : 0
      console.log('参数：' + JSON.stringify(this.params))
    },
    // 启动车辆
    run() {
      if (this.is_running) return
      if (this.running_sh) {
        clearInterval(this.running_sh)
      }
      // 2024-07-23 添加
      if (this.params.methanol_left_amount > this.maxMethanolAmount) {
        this.notifyMessage('maxMethanolAmount', 1, `甲醇余量不能超过${this.maxMethanolAmount}L`)
        return;
      }
      if (this.params.water_left_amount > this.maxWaterAmount) {
        this.notifyMessage('maxWaterAmount', 1, `水余量不能超过${this.maxWaterAmount}L`)
        return;
      }
      if (this.params.power_left_amount > this.params.power_full_amount) {
        this.notifyMessage('power_full_amount', 1, `电余量不能超过40kwh`)
        return;
      }

      this.params.mileage = 0
      this.params.power_consumption = 0
      this.params.run_seconds = 0
      this.params.machine_run_seconds = 0
      this.params.machine_methanol_consume_amount = 0
      this.params.machine_water_consume_amount = 0
      this.params.machine_create_power = 0
      this.params.running_speed = this.params.last_running_speed > 0 ? this.params.last_running_speed : 60 // 默认60km/h
      this.is_running = true
      this.machine_is_running = false
      this.startRunning()
    },
    pause() {
      if (!this.is_running) return
      if (this.running_sh) {
        clearInterval(this.running_sh)
      }
      this.params.last_running_speed = this.params.running_speed
      this.params.running_speed = 0
      this.is_running = false
      this.machine_is_running = false
      this.params.last_stop_timestamp = 0
      this.updateParams()
    },
    startRunning() {
      let that = this
      that.running_sh = setInterval(() => {
        let try_start_machine = false
        // 1
        let sub_methanol = 0.000695
        let add_power = 0.00138
        let sub_water = parseFloat((sub_methanol * that.params.machine_water_methanol_ratio).toFixed(6))
        let machine_can_running = that.params.methanol_left_amount >= sub_methanol && that.params.water_left_amount >= sub_water
        if (!that.machine_is_running && machine_can_running && (that.params.power_left_amount / that.params.power_full_amount) < 0.2) {
          that.machine_is_running = true
          try_start_machine = true
        }
        that.params.machine_methanol_consume_ratio = computed(() => {
          return that.machine_is_running ? (sub_methanol * 3600).toFixed(2) : 0
        })
        that.params.machine_water_consume_ratio = computed(() => {
          return that.machine_is_running ? (sub_water * 3600).toFixed(2) : 0
        })
        if (that.machine_is_running && !machine_can_running) {
          // 水|醇 不足
          that.machine_is_running = false
          sub_methanol = 0
          add_power = 0
          sub_water = 0
          that.notifyMessage('water-or-methanol-run-over', 2, '水/甲醇不足，停止发电')
        }
        if (that.machine_is_running) {
          that.params.methanol_left_amount = parseFloat((that.params.methanol_left_amount - sub_methanol).toFixed(4))
          that.params.water_left_amount = parseFloat((that.params.water_left_amount - sub_water).toFixed(4))
          let now_power_left_amount = parseFloat((that.params.power_left_amount + add_power).toFixed(4))
          if (now_power_left_amount >= that.params.power_full_amount) {
            // 充满电
            now_power_left_amount = that.params.power_full_amount
            that.machine_is_running = false
            that.notifyMessage('machine-power-full', 2, '电已充满，停止发电')

          }
          if (that.params.last_stop_timestamp > 0 && that.params.running_speed === 0 && Math.floor((new Date()).getTime() / 1000) - that.params.last_stop_timestamp > 600) {
            that.machine_is_running = false
            that.notifyMessage('machine-power-long', 2, '停车发电时间过长，停止发电')
          }
          that.params.power_left_amount = now_power_left_amount
          // 醇
          that.params.machine_methanol_full_consume_amount = parseFloat((that.params.machine_methanol_full_consume_amount + sub_methanol).toFixed(4))
          that.params.machine_methanol_consume_amount = parseFloat((that.params.machine_methanol_consume_amount + sub_methanol).toFixed(4))
          // 水
          that.params.machine_water_full_consume_amount = parseFloat((that.params.machine_water_full_consume_amount + sub_water).toFixed(4))
          that.params.machine_water_consume_amount = parseFloat((that.params.machine_water_consume_amount + sub_water).toFixed(4))

          that.params.machine_create_power = parseFloat((that.params.machine_create_power + add_power).toFixed(4))
        }
        // 2
        let running_speed = that.params.running_speed
        let running_mileage = parseFloat((running_speed / 3600).toFixed(4))
        // 0.2表示平均耗电量修改20kwh/100公里（之前0.15）
        let power_consumption = parseFloat(((Math.abs(running_speed - 60) * 0.0006 + 0.2) * running_mileage).toFixed(4))
        that.debug_content = `甲醇-${sub_methanol},水-${sub_water},充电+${add_power},时速${running_speed},里程+${running_mileage},耗电-${power_consumption}`
        if (power_consumption > that.params.power_left_amount) {
          // 电量不足
          that.params.running_speed = 0
          that.notifyMessage('machine-power-off', 2, '电量不足，停止运行')
          return
        }
        if (that.params.running_speed < 1 && !that.machine_is_running) {
          that.pause()
          return
        }
        that.params.mileage = parseFloat((that.params.mileage + running_mileage).toFixed(4))
        that.params.full_mileage = parseFloat((that.params.full_mileage + running_mileage).toFixed(4))
        that.params.full_power_consumption = parseFloat((that.params.full_power_consumption + power_consumption).toFixed(4))
        that.params.power_consumption = parseFloat((that.params.power_consumption + power_consumption).toFixed(4))
        that.params.power_left_amount = parseFloat((that.params.power_left_amount - power_consumption).toFixed(4))
        that.params.full_run_seconds += 1
        that.params.run_seconds += 1
        if (that.machine_is_running) {
          that.params.machine_full_run_seconds += 1
          that.params.machine_run_seconds += 1
        }
        if (try_start_machine && that.machine_is_running) {
          that.notifyMessage('machine-power-lower', 2, '电量不足，启用发电')
        }
        that.checkRules()
      }, 100)
    },
    checkRules() {
      let that = this
      for (let key in that.params) {
        window[key] = that.params[key]
      }
      window.now_timestamp = Math.floor((new Date()).getTime() / 1000)
      for (let i in that.rules) {
        let id = that.rules[i].id
        let formula = that.rules[i].formula
        let level = that.rules[i].level
        let message = that.rules[i].message
        let result = false
        try {
          result = eval(formula)
          // console.log(formula, result)
        } catch (e) {
          console.log('eval error', e)
          result = false
        }
        if (result) {
          that.notifyMessage(id, level, message)
        }
      }
    },
    notifyMessage(id, level, message) {
      console.log('---弹框通知----', id, level, message)
      let that = this
      let index = that.notifyRules.findIndex(item => {
        return item.id === id
      })
      if (index >= 0) return
      that.notifyRules.push({
        id: id,
        level: level,
        message: message,
      })
    },
    removeNotify(index) {
      this.notifyRules.splice(index, 1)
    },
    // 按键下
    handleKeyDown(e) {
      if (!this.is_running) return
      if (e.code === "ArrowUp" && !e.repeat) {
        this.keyStatus = "ArrowUp"
        this.speedAddStart()
      }
      if (e.code === "ArrowDown" && !e.repeat) {
        this.keyStatus = this.params.running_speed > 0 ? "ArrowDown" : null
        this.speedSubStart()
      }
    },
    handleKeyUp(e) {
      this.keyStatus = null
      if (e.code === "ArrowUp") {
        this.speedAddEnd()
      }
      if (e.code === "ArrowDown") {
        this.speedSubEnd()
      }
    },
    speedAddStart() {
      if (!this.is_running) return
      this.speedAddEnd()
      this.speed_add_sh = setInterval(() => {
        if (this.is_running) {
          this.speedAdd()
        } else {
          this.speedAddEnd()
        }
      }, 150)
    },
    speedAddEnd() {
      this.speed_add_sh && clearInterval(this.speed_add_sh)
      this.speed_add_sh = null
    },
    speedSubStart() {
      if (!this.is_running) return
      this.speedSubEnd()
      this.speed_sub_sh = setInterval(() => {
        if (this.is_running) {
          this.speedSub()
        } else {
          this.speedSubEnd()
        }
      }, 150)
    },
    speedSubEnd() {
      this.speed_sub_sh && clearInterval(this.speed_sub_sh)
      this.speed_sub_sh = null
      // 按钮恢复颜色
      if (this.params.running_speed < 1) {
        this.keyStatus = null
      }
    },
    speedAdd() {
      if (!this.is_running) return
      this.params.running_speed += 1
    },
    speedSub() {
      if (!this.is_running) return
      if (this.params.running_speed > 0) {
        this.params.running_speed -= 1
        if (this.params.running_speed < 1) {
          this.params.last_stop_timestamp = Math.floor((new Date()).getTime() / 1000)
        }
      } else {
        this.keyStatus = null
      }
    },
  }
}
</script>

<style scoped lang="scss">
.car-paper {
  width: 100vw;
  height: 100vh;
  background: #0C131B;
  display: flex;
  justify-content: center;
  align-items: center;
}

.car-page {
  width: 1920px;
  height: 1080px;
  background: #0C131B;
  background-size: cover;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .text-left {
    text-align: left;
  }

  .text-right {
    text-align: right;
  }

  img {
    -webkit-user-drag: none;
  }

  /*中间大标题*/
  .dashboard-title {
    position: absolute;
    top: 76px;
    left: 0;
    right: 0;
    height: 44px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 40px;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }

  /*左下角按钮框*/
  .left-bottom-box {
    position: absolute;
    width: 140px;
    height: 30px;
    bottom: 12px;
    left: 90px;
    z-index: 100;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .refresh {
      width: 30px;
      height: 30px;
      cursor: pointer;
    }

    .debug {
      width: 28px;
      height: 28px;
      cursor: pointer;
    }

    .setting {
      font-size: 27px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  /*左边信息栏*/
  .left-info-wrapper {
    position: absolute;
    top: 200px;
    left: 90px;
    width: 260px;
    height: 542px;
    color: #fff;

    .left-title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 20px;
      color: #FFFFFF;
      text-align: center;
      height: 28px;
      line-height: 28px;
    }

    .mileage-box {
      padding: 16px 10px;

      .content {
        padding-top: 16px;
        text-align: center;

        .num {
          font-weight: 400;
          //font-size: 60px; /*设计*/
          font-size: 60px;
          color: #FFFFFF;
          height: 70px;
          line-height: 70px;
        }

        .unit {
          padding-left: 8px;
          font-size: 16px;
        }
      }

    }

    .speed-box {
      padding: 16px 14px;
      margin-top: 40px;
      //background: rgba(255, 255, 255, 0.1);
      text-align: center;

      .speed-img {
        padding-top: 16px;
        padding-bottom: 16px;
        text-align: center;

        & > img {
          width: 40px;
          height: 40px;
        }
      }

      .num {
        height: 182px;
        line-height: 182px;
        font-weight: bold;
        font-size: 139px;
        color: #FFFFFF;
      }

      .unit {
        padding-top: 16px;
        font-size: 16px;
      }
    }
  }

  /*右边信息栏*/
  .right-info-wrapper {
    position: absolute;
    top: 206px;
    right: 90px;
    width: 260px;
    height: 542px;
    //border: 1px solid red;
    color: #ffffff;

    .text-right {
      text-align: right;
    }

    .text-left {
      text-align: left;
    }

    .padding-top-16 {
      padding-top: 16px;
    }

    .color-water {
      background: rgba(0, 228, 255, 0.1);

      &.active {
        background: #00E4FF;
      }

      &.warning {
        background: red;
      }
    }


    .color-methanol {
      background: rgba(129, 251, 184, 0.1);

      &.active {
        background: #81FBB8;
      }

      &.warning {
        background: red;
      }
    }

    .color-electric {
      background: rgba(255, 247, 32, 0.1);

      &.active {
        background: #FFF720;
      }

      &.warning {
        background: red;
        position: relative;
        //&::after {
        //  z-index: 1;
        //  position: absolute;
        //  top: -1px;
        //  left: -1px;
        //  display: block;
        //  content: "";
        //  width: 5px;
        //  height: 24px;
        //  box-sizing: border-box;
        //  background-color: red;
        //  animation: outerMove 1s infinite ease-in-out;
        //}
      }
    }


    .right-title {
      height: 28px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 28px;
      text-align: center;
      margin-bottom: 20px;
    }

    .number {
      font-size: 26px; /*设计28px*/
      line-height: 28px
    }

    .unit {
      font-size: 16px;
      line-height: 18px;
      padding-left: 3px;
    }

    .name {
      font-size: 10px;
      line-height: 16px;
      height: 16px;
    }


    /*横线*/
    .h-line {
      width: 22px;
      height: 3px;
      margin-top: 8px;

      &:first-child {
        margin-top: 0;
      }
    }

    .v-line {
      width: 3px;
      height: 22px;
      margin-left: 8px;

      &:first-child {
        margin-left: 0;
      }
    }

    .methanol-box {
      padding: 16px 10px;
      height: 338px;

      .content {
        display: flex;

        & > div {
          flex: 1 !important;
        }

        .methanol {
          padding-right: 12px;
        }

        .water {
          padding-left: 10px;
        }
      }


    }

    .electric-box {
      margin-top: 40px;
      padding: 16px 24px;

      .line-box {
        display: flex;
      }

      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 16px;

      }
    }
  }

  /*底部操作*/
  .bottom-opr-wrapper {
    position: absolute;
    bottom: 80px;
    left: 656px;
    width: 568px;
    height: 100px;
    z-index: 100;

    .opr-btn {
      width: 100px;
      height: 100px;
      margin-left: 56px;
      background-size: cover;
      display: inline-block;
      line-height: 100px;
      text-align: center;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      cursor: pointer;

      &:first-child {
        margin-left: 0;
      }
    }
  }

  /*中间图片*/
  .dashboard-container {
    position: relative;
    width: 1471px;
    height: 1015px;
    //border: 1px solid red;
    margin: 0 auto;
    padding-left: 181px;
    padding-top: 180px;

    .car-container {
      position: relative;
      box-sizing: border-box;
      width: 1108px;
      height: 618px;

      .car-img {
        position: absolute;
        right: 0;
        top: 136px;
        width: 1002px;
        height: 366px;
        z-index: 1;
      }

      /*流动*/
      .car-line-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        width: 1108px;
        height: 618px;
        z-index: 50;

        .car-lines {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }

        .car-words {
          position: absolute;
          top: 68px;
          right: 94px;
          width: 573px;
          height: 549px;
          z-index: 100;
        }


        .gas-y-1 {
          width: 587px;
          height: 20px;
          position: absolute;
          top: 86px;
          right: 202px;
          z-index: 30;
          background-image: url("/svg/gas-yellow.svg");
          background-size: inherit;
          background-position: 0 0;
          animation: gasToRight 5s infinite linear;
        }

        .gas-y-2 {
          position: absolute;
          left: 309px;
          top: 95px;
          height: 170px;
          width: 20px;
          z-index: 30;
          background-image: url("/svg/gas-yellow.svg");
          background-size: inherit;
          background-position: 0 0;
          animation: gasToBottom 5s infinite linear;
        }

        .gas-y-3 {
          position: absolute;
          right: 194px;
          top: 95px;
          height: 118px;
          width: 20px;
          z-index: 30;
          //background: saddlebrown;
          background-image: url("/svg/gas-yellow.svg");
          background-size: inherit;
          background-position: 0 0;
          animation: gasToTop 5s infinite linear;
        }

        .gas-y-4 {
          position: absolute;
          right: 202px;
          top: 301px;
          height: 20px;
          width: 212px;
          z-index: 30;
          //background: deeppink;
          background-image: url("/svg/gas-yellow.svg");
          background-size: inherit;
          background-position: 0 0;
          animation: gasToLeft 5s infinite linear;
        }

        .gas-y-6 {
          position: absolute;
          top: 299px;
          left: 385px;
          z-index: 30;
          width: 200px;
          height: 20px;
          //background: #d77b1e;
          background-image: url("/svg/gas-yellow.svg");
          background-size: inherit;
          background-position: 0 0;
          animation: gasToRight 5s infinite linear;
        }


        .gas-y-5 {
          position: absolute;
          right: 194px;
          top: 280px;
          height: 33px;
          width: 20px;
          z-index: 30;
          //background: green;
          background-image: url("/svg/gas-yellow.svg");
          background-size: inherit;
          background-position: 0 0;
          animation: gasToTop 5s infinite linear;
        }

        .gas-blue-1 {
          position: absolute;
          left: 110px;
          bottom: 195px;
          height: 20px;
          width: 362px;
          z-index: 30;
          //background: blue;
          background-image: url("/svg/gas-blue.svg");
          background-size: inherit;
          background-position: 0 0;
          animation: gasToLeft 5s infinite linear;
        }

        .gas-pink-1 {
          position: absolute;
          right: 120px;
          bottom: 195px;
          height: 20px;
          width: 180px;
          z-index: 30;
          //background: blue;
          background-image: url("/svg/gas-pink.svg");
          background-size: inherit;
          background-position: 0 0;
          animation: gasToRight 5s infinite linear;
        }

        .gas-pink-2 {
          position: absolute;
          right: 113px;
          bottom: 205px;
          height: 85px;
          width: 20px;
          z-index: 30;
          //background: palevioletred;
          background-image: url("/svg/gas-pink.svg");
          background-size: inherit;
          background-position: 0 0;
          animation: gasToBottom 5s infinite linear;
        }

        .gas-green-1 {
          position: absolute;
          right: 471px;
          bottom: 31px;
          height: 131px;
          width: 20px;
          z-index: 30;
          //background: gray;
          background-image: url("/svg/gas-green.svg");
          background-size: inherit;
          background-position: 0 0;
          animation: gasToBottom 5s infinite linear;
        }

        .gas-green-2 {
          position: absolute;
          right: 250px;
          bottom: 22px;
          height: 20px;
          width: 229px;
          z-index: 30;
          //background: #bba99d;
          background-image: url("/svg/gas-green.svg");
          background-size: inherit;
          background-position: 0 0;
          animation: gasToLeft 5s infinite linear;
        }

      }


      /*轮胎*/
      .tyre {
        position: absolute;
        width: 163px;
        height: 163px;
        z-index: 5;

        &.left {
          left: 215px;
          bottom: 83px;
        }

        &.right {
          right: 86px;
          bottom: 84px;
        }

        &.round {
          animation: round .6s infinite linear;
        }
      }
    }
  }

  /*报警提示框*/
  .tip-container {
    position: fixed;
    right: 20px;
    top: 20px;
    z-index: 110;
    width: 300px;
    height: auto;

    .tip-box {
      width: 300px;
      height: 134px;
      margin-bottom: 8px;
      position: relative;
      background-size: cover;
      animation: bounceInLeft 1s linear;
      //background: #0C131B;

      .top-close {
        position: absolute;
        right: 0;
        top: 0;
        width: 30px;
        height: 30px;
        z-index: 120;
      }

      .tip-color-1 {
        color: #FF386B;
      }

      .tip-color-2 {
        color: #F5E74F;
      }

      .tip-color-3 {
        color: #1FFFFF;
      }

      .img-box {
        padding-top: 24px;
        padding-bottom: 11px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;

        & > img {
          width: 32px;
          height: 30px;
        }

        & > span {
          padding-left: 12px;
          font-weight: bold;
          font-size: 20px;
        }
      }

      .msg {
        text-align: center;
        color: #ffffff;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        padding: 0 30px;
        height: 44px;
        overflow: hidden;
      }


    }
  }
}

@keyframes bounceInLeft {
  0% {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }

  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }

  75% {
    transform: translate3d(-10px, 0, 0);
  }

  90% {
    transform: translate3d(5px, 0, 0);
  }

  100% {
    transform: none;
  }
}


/* 轮胎滚动动画 */
@keyframes round {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

@keyframes gasToRight {
  0% {
    background-position: 100px 0;
  }
}

@keyframes gasToLeft {
  0% {
    background-position: -100px 0;
  }
}

@keyframes gasToBottom {
  0% {
    background-position: 0 -100px;
  }
}

@keyframes gasToTop {
  0% {
    background-position: 0 100px;
  }
}

@keyframes outerMove {
  /**0%~50% 0s~ 0.7s前的时间 此时内圈放大，扩散圈等待时机出现**/
  0% {
    opacity: 0;
  }
  /**10% 此时内圈已经放大一段时间， 扩散全显示opacity设为1，倍率为1 **/
  10% {
    opacity: 1;
    transform: scale(1);
  }
  /**50%到100%是动画0.7s~1.4s的时间 此时内圈缩小，扩散圈变为1.3倍，但是透明度设为0**/
  50%,
  100% {
    transform: scale(1.3);
    opacity: 0;
  }
}


.params-container {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px;
  color: #ffffff;
  z-index: 60;
  background: rgba(0, 0, 0, .8);

  p {
    font-size: 14px;
    line-height: 1.4;
  }

  hr {
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
  }
}
</style>

